/* eslint-disable @typescript-eslint/unbound-method */
import { Injectable, forwardRef } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Router } from '@angular/router'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { ScrollHelperService } from '@se-po/shared-data-access-helpers'
import { AnalyticsService, UserDuplicateLookupService } from '@se-po/shared-data-access-services'
import { CookieService } from 'ngx-cookie-service'
import { first } from 'rxjs/operators'
import { SeFeFormService } from 'se-fe-form-service'
import { UserServiceResources as us } from 'se-resource-types'

import { AccountInfoFormCreateService } from './account-info-form-create.service'

@Injectable({
  providedIn: 'root',
  useExisting: forwardRef(() => AccountInfoFormSubmitService),
  deps: [Router]
})
export abstract class AccountInfoFormSubmitter {
  public abstract submitting: boolean
  public abstract matchingDupe: us.UserDuplicateLookupResult
  public abstract matchingEmail: string
  public abstract submit: (store: StoreService) => void
  public abstract validateAndSubmit: (form: UntypedFormGroup, store: StoreService) => void
}

@Injectable({
  providedIn: 'root'
})
export class AccountInfoFormSubmitService implements AccountInfoFormSubmitter {
  public submitting = false
  public matchingEmail: string
  public matchingDupe: us.UserDuplicateLookupResult
  public agelock = false
  public underAgeCookieName = 'agelock'

  constructor(
    private analyticsService: AnalyticsService,
    private dupeService: UserDuplicateLookupService,
    private formCreator: AccountInfoFormCreateService,
    private formService: SeFeFormService,
    private router: Router,
    private scrollHelper: ScrollHelperService,
    private cookieService: CookieService
  ) { }

  public validateAndSubmit(form: UntypedFormGroup, store: StoreService): void {
    this.submitting = true

    if (!this.formService.isValid(form)) {
      this.submitting = false
      this.analyticsService.trackFormErrors(form)
      if (form.controls?.dateOfBirth?.errors?.required) {
        return
      }
      else if (form.controls?.dateOfBirth?.errors?.dob18) {
        this.cookieService.set(this.underAgeCookieName, '1', {
          expires: 1, // 1 day
        })
        this.agelock = true
      }
      return
    }
    this.submit(store)
  }

  public submit(store: StoreService): void {
    this.analyticsService.seEvent('ContinueToSignUpClick')
    store.accountInfo = this.formCreator.value
    this.dupeService.search(store.userDuplicateLookupParams)
      .pipe(first())
      .subscribe((result) => {
        store.dupes = result
        if (!result) return this.navigate([store.basePath, 'create-password'])

        else if (result.user_duplicate_lookup_results[0].confidence === 'exact_email') {
          this.matchingEmail = result.email
          this.matchingDupe = result.user_duplicate_lookup_results[0]
          this.submitting = false
          this.scrollHelper.scrollTo(0, 0)
          this.analyticsService.trackError('EmailAddressAlreadyInUse')
        }
        else {
          store.nextPath = 'create-password'
          return this.navigate([store.basePath, 'match'])
        }
      })
  }

  private navigate(path: string[]): void {
    this.submitting = false
    this.router.navigate(path)
  }
}
